import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a Date object to YYYY-MM-DD string in local timezone
 * This prevents timezone shift issues when storing dates
 */
export function formatDateForDB(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Parses a YYYY-MM-DD string (as returned by the backend) into a local Date at midnight.
 * The inverse of formatDateForDB — avoids the timezone shift `new Date("YYYY-MM-DD")` can
 * cause, since that string form is parsed as UTC rather than local time.
 */
export function parseDateFromDB(dateStr: string): Date {
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}
